import { render, staticRenderFns } from "./NormalResultChart.vue?vue&type=template&id=5b1e159c&"
import script from "./NormalResultChart.vue?vue&type=script&lang=js&"
export * from "./NormalResultChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports